import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { API_BASE } from '../constants/eventGrid';

/**
 * SPA fallback if nginx short-link proxy is unavailable.
 * Prefer server 302 via /seo/e/:code for a seamless redirect.
 */
const ShortEventLinkPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const resolve = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/events/short/${encodeURIComponent(code)}`);
        const data = await response.json().catch(() => ({}));

        if (cancelled) return;

        if (response.ok && data?.success && data?.data?.eventId) {
          // Hard navigate so the event page loads cleanly without the intermediate shell lingering.
          window.location.replace(`/events/${data.data.eventId}`);
          return;
        }

        setError(data?.message || 'Event not found');
      } catch {
        if (!cancelled) setError('Event not found');
      }
    };

    resolve();

    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  if (!error) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-amber-50">
      <div className="text-center max-w-md">
        <div className="text-4xl mb-4">😔</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Event not found</h2>
        <p className="text-gray-600 mb-6">{error}</p>
        <Link
          to="/events"
          className="inline-flex items-center justify-center gap-2 bg-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors"
        >
          Back to Events
        </Link>
      </div>
    </div>
  );
};

export default ShortEventLinkPage;
